<div>
  <app-toasts
    aria-live="polite"
    aria-atomic="true"></app-toasts>
  <router-outlet />
</div>
